/** A toolbar filter of one value: a native select that reads "All …" when nothing is chosen. */

import { ChevronDown } from 'lucide-react';

export interface FilterOption {
  value: string;
  label: string;
}

export function FilterSelect({
  label,
  allLabel,
  value,
  options,
  onChange,
}: {
  label: string;
  allLabel: string;
  value: string | null;
  options: FilterOption[];
  onChange: (value: string | null) => void;
}) {
  return (
    <span className="select-wrap">
      <select className="toolbar-select" aria-label={label} value={value ?? ''} onChange={(e) => onChange(e.target.value || null)}>
        <option value="">{allLabel}</option>
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <ChevronDown aria-hidden="true" />
    </span>
  );
}
